<template>
  <div class="stages">
    <section-heading>The colloquium has two stages Set Up</section-heading>
    <div class="stages__wrapper">
      <tabs mode="three" upperCase>
        <tab title="Set Up - Intensive">
          <stages-tab :stageInfo="stage1">
            <ul class="stages__list">
              <li class="stages__listItem">
                <p class="stages__listInfo">Realise what are the <span>TOP 3</span> things that you are really getting paid</p>
              </li>
              <li class="stages__listItem">
                <p class="stages__listInfo">Discover your <span>Purpose</span> & Find your Moment to live for</p>
              </li>
              <li class="stages__listItem">
                <p class="stages__listInfo">Define 4 Games of your life to <span>LIVE your Purpose</span></p>
              </li>
              <li class="stages__listItem">
                <p class="stages__listInfo">Create a Detailed <span>Action Plan</span> to Convert your Games into Reality</p>
              </li>
              <li class="stages__listItem">
                <p class="stages__listInfo"><span>Eliminate Reasons</span> that you unconsciously use to not take action</p>
              </li>
              <li class="stages__listItem">
                <p class="stages__listInfo"><span>FIND WAYS </span> & Means <span>TO EXECUTE</span> your Detailed Actions Plan</p>
              </li>
            </ul>
          </stages-tab>
        </tab>
        <tab title="Execution a- Habit Builders">
          <stages-tab :stageInfo="stage2"></stages-tab>
        </tab>
        <tab title="ONGOING SUPPORT">
          <stages-tab :stageInfo="stage3"></stages-tab>
        </tab>
      </tabs>  
    </div>
    <div class="stages__videoTextWrapper">
      <div class="stages__wrapperItem stages__textWrapper">
        <p class="stages__info">MANAN VASA SHOWS YOU HOW HE WILL BE WORKING WITH YOU DURING THE 90 DAYS OF THE COLLOQUIUM THE GAIN LIVINAR</p>
      </div>
      <div class="stages__wrapperItem">
        <div class="stages__videoWrapper">
          <div class="stages__btns">
            <img src="../../assets/image/common/playbtn.png" class="img-fluid stages__playBtn">
            <section-button>Watch Now</section-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Heading from '../Shared/Heading';
import Tab from './AB-Tab.vue'
import Tabs from './AB-Tabs.vue'
import Button from "../Shared/Button";
import Reviewing from "../../assets/image/about/stage2/reviewing.png";
import Learning from "../../assets/image/about/stage2/learning.png";
import Planning from "../../assets/image/about/stage2/planning.png";
import Success from "../../assets/image/about/stage3/success.png";
import Accountability from "../../assets/image/about/stage3/accountability.png";
import Audits from "../../assets/image/about/stage3/audits.png";
import StagesTab from "../Shared/StagesTab";
export default {
  data(){
    return{
      stage1:{
        stageName:'stages__tab1',
        title:'MILLION DOLLAR HABITS INTENSIVE',
        desc:'2 Days of Practical Exercises to apply our Proprietary Tools to:',
        imgText:'Go back convinced that you can produce any result in any area of your life by simply altering your relationship with Time, Focus, Clarity & Reality.',
        buttonText:'See how our Graduates have benefitted',
      },
      stage2:{
        stageName:'stages__tab2',
        title:'HABIT BUILDER SERIES',
        desc:'9 Weekly Hardcore Practical Sessions to implement Manan’s “Make it Happen Framework” &copy; to accomplish your 4 Goals by:',
        imgText:'You will master Million Dollar Habits to Produce Tangible Results week after week ON YOUR OWN at the end of the Habit Builder Series.',
        buttonText:'See how OUR GRADUATES have benefitted',
        list:[
          {
            image:Reviewing,
            name:'Reviewing',
            info:'Audit your weekly progress on all 4 Goals of your Life and become Accountable for your actions and results.'
          },
          {
            image:Learning,
            name:'Learning',
            info:'Realise & unlearn the unconscious habits that came in your way to implement your last week’s plan and learn the surest, shortest, fastest way to produce results over the next 7 days.'
          },
          {
            image:Planning,
            name:'Planning',
            info:'Learn the Art of Choosing and Accepting what you will do and YOU WON’T DO and Commit what results you will produce in the next 7 days by making your detailed action plan for the week.'
          }
        ]
      },
      stage3:{
        stageName:'stages__tab3',
        title:'ONGOING SUPPORT',
        desc:'Before every Habit Builder, your Personal Consultant will hand-hold you using:',
        imgText:'We will roll up our sleeves & work with you & STAND with you throughout the 90 days till you hit your Goals and recover your investment that you put in us.',
        buttonText:'Enrol got MDH Demo now',
        list:[
          {
            image: Success,
            name:'Success Gym',
            info:'Work closely with your personal consultant who will handhold you to overcome specific Personal Challenges in implementing the Colloquium in any of the 4 Personal Projects.'
          },
          {
            image: Accountability,
            name:'Accountability Maximizer',
            info:'We make you accountable for your weekly results via reminders and follow-up calls.'
          },
          {
            image:Audits,
            name:'CLARITY AUDITS',
            info:'Every week, we track your habits and results via our special surveys & trackers that let us know if your results are plain accidental or if unproductive habits are transforming to Million Dollar Habits.'
          },
        ]
      }
    }
  },
  components:{
    'section-heading':Heading,
    "stages-tab": StagesTab,
    "section-button": Button,
    Tab,
    Tabs
  }
}
</script>
<style scoped>
.stages{
  margin-bottom: 20px;
}
.stages__wrapper{
  margin:28px 0 50px 0;
}

.stages__videoTextWrapper{
  display: flex;
}

.stages__wrapperItem{
  width: 50%;
}

.stages__textWrapper{
  background-color:var(--primary-color);
  color: var(--secondary-color);
  text-align: center;
}

.stages__info{
  font-size: 39px;
  font-family: "Seravek-Medium";
  margin-bottom: 0;
  padding: 136px 0;
  width:60%;
  margin:0 auto;
}
.stages__videoWrapper{
  background-image:url('../../assets/image/common/manan.png');
  background-position: top center;
  background-repeat: no-repeat;
  background-size:cover;
  width: 100%;
  height: 100%;
  position: relative;
}

.stages__playBtn{
  display: block;
  margin: 0 auto;
  padding-bottom: 25px;
  cursor: pointer;
}

.stages__btns{
  position: absolute;
  left: 50%;
  bottom: 10%;
  transform: translateX(-50%);
}

/* Mobiles (Portrait) */
@media (min-width: 320px) and (max-width: 480px) {
  .stages__videoTextWrapper{
    flex-direction: column;
  }

  .stages__wrapperItem{
    width: 100%;
  }

  .stages__info {
    font-size: 20px;
    padding: 35px 0;
    width: 85%;
  }

  .stages__videoWrapper{
    height: 340px;
  }

  .stages__playBtn{
    width:60%;  
  }

  .stages__btns{
    bottom: 6%;
  }
}

/* Low Resolution Tablets, Mobiles (Landscape) */
@media (min-width: 481px) and (max-width: 767px) {
   .stages__info{
      font-size: 22px;
      padding: 50px 0;
      width: 80%;
   }
   .stages__playBtn{
     width: 50%;
     padding-bottom: 20px;
   }
}
/* Tablets, Ipads (portrait) */
@media (min-width: 768px) and (max-width: 1024px) {
  .tab__content{
    padding: 40px 0;
  }
  .tab__item img{
    margin: 10px 0;
  }
  .tab__number{
    font-size: 28px;
  }
  .work__wrapper{
    margin: 24px 0 35px 0;
  }
  .stages__info{
    font-size: 24px;
    padding: 60px 0;
    width: 70%;
  }
   .stages__playBtn{
     width: 50%;
     padding-bottom: 25px;
   }
}
</style>